export default __webpack_public_path__ + "static/media/user-sky.3c228acb.png";